import { z } from 'zod';
import {
  FamilyDetailCoreTreeSchema,
  StudentsDashboardTreeSchema,
} from '@triedge/students-families-domain';
import {
  defineObjectTreeRegistry,
  defineObjectTreeResource,
} from '@triedge/rtk-abstractions';

export const studentsFamiliesObjectTreeRegistry = defineObjectTreeRegistry({
  dashboard: defineObjectTreeResource({
    key: 'students.dashboard',
    argsSchema: z.object({
      limit: z.number().int().positive().optional(),
      offset: z.number().int().nonnegative().optional(),
    }),
    payloadSchema: StudentsDashboardTreeSchema,
    warmScopes: ['page', 'app', 'persona'],
  }),
  familyCore: defineObjectTreeResource({
    key: 'students.family.core',
    argsSchema: z.object({
      familyId: z.string().min(1),
    }),
    payloadSchema: FamilyDetailCoreTreeSchema,
    warmScopes: ['lazy', 'page', 'app', 'persona'],
  }),
});

export type StudentsFamiliesObjectTreeRegistry = typeof studentsFamiliesObjectTreeRegistry;
